/**
 * Client classification by sector / nature.
 * Align with `src/modules/client/domain/client.constants.ts` (`ClientType`).
 */
export enum ClientType {
  GOVERNMENT = "GOVERNMENT",
  PRIVATE = "PRIVATE",
  INDUSTRIAL = "INDUSTRIAL",
}

export type ClientTypeValue = `${ClientType}`;

export const ClientTypeLabelMap: Record<ClientType, string> = {
  [ClientType.GOVERNMENT]: "Government",
  [ClientType.PRIVATE]: "Private",
  [ClientType.INDUSTRIAL]: "Industrial",
};

/**
 * Seeded `client_sectors` rows (see migration `20260421150000-client-organizations-and-contacts.js`).
 * IDs are stable for a fresh migrate; replace with `GET /clients/sectors` when exposed.
 */
export const CLIENT_SECTOR_SEED: ReadonlyArray<{ id: number; name: string }> = [
  { id: 1, name: "Government & Public Sector" },
  { id: 2, name: "Industrial Clients" },
  { id: 3, name: "Commercial & Private Organizations" },
];
